webpackJsonp([1],Array(33).concat([
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_screens_Error404__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_screens_Error404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_screens_Error404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ThreeRemix__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ThreeRemix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ThreeRemix__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'hash',
	routes: [{
		name: 'home',
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
	}, {
		name: 'threeJSattempt',
		path: '/three-remix',
		component: __WEBPACK_IMPORTED_MODULE_5__components_ThreeRemix___default.a,
		meta: {
			title: 'MrDoob x IanPaschal - Three.js + WebGL + Vue'
		}
	}, {
		name: 'error',
		path: '*',
		component: __WEBPACK_IMPORTED_MODULE_4__components_screens_Error404___default.a,
		meta: {
			title: 'Not Found'
		}
	}]
}));

/***/ }),
/* 35 */
/***/ (function(module, exports) {

(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-103176131-1', 'auto');
ga('send', 'pageview');

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(21);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	state: {
		scene: new __WEBPACK_IMPORTED_MODULE_0_three__["a" /* Scene */](),
		bounds: {
			x: 200,
			y: 200,
			z: 400
		},
		sliceThickness: 2,
		move: true,
		gui: {
			showObjectEdge: true,
			showGizmos: false,
			showSceneBorders: true,
			objectEdgeSize: 8,
			gizmoSize: 64
		},
		camera: new __WEBPACK_IMPORTED_MODULE_0_three__["b" /* PerspectiveCamera */]()
	}
}));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Cover__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__screens_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Intro__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__screens_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Skills__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Skills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__screens_Skills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Connect__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__screens_Connect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',
	components: {
		Cover: __WEBPACK_IMPORTED_MODULE_1__screens_Cover___default.a,
		NavMenu: __WEBPACK_IMPORTED_MODULE_0__Navigation___default.a,
		Intro: __WEBPACK_IMPORTED_MODULE_2__screens_Intro___default.a,
		Skills: __WEBPACK_IMPORTED_MODULE_3__screens_Skills___default.a,
		Connect: __WEBPACK_IMPORTED_MODULE_4__screens_Connect___default.a
	},
	data: function data() {
		return {
			screens: ['cover', 'intro', 'skills', 'connect']
		};
	}
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'navigation',
	props: ['active', 'items'],
	filters: {
		title: function title(value) {
			return {
				'cover': 'Top',
				'intro': 'Intro',
				'skills': 'Skills',
				'projects': 'Projects',
				'blog': 'Blog',
				'connect': 'Connect'
			}[value];
		}
	},
	methods: {
		navigateTo: function navigateTo(screenName) {
			var _this = this;

			this.$scrollTo('#screen-' + screenName, {
				onDone: function onDone() {
					_this.$emit('screenSet', screenName);
				},
				duration: 300,
				easing: 'ease-out',
				cancelable: true
			});
		}
	}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resize_directive__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resize_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resize_directive__);
//
//
//
//
//
//
//
//
//
//



// import OrbitControlModule from "three-orbit-controls";
// const OrbitControls = OrbitControlModule(Three);

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'perspective-viewport',
	directives: { resize: __WEBPACK_IMPORTED_MODULE_1_vue_resize_directive___default.a },
	props: {
		mouseControlEnabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data: function data() {
		return {
			renderer: new __WEBPACK_IMPORTED_MODULE_0_three__["h" /* WebGLRenderer */](),
			raycaster: new __WEBPACK_IMPORTED_MODULE_0_three__["i" /* Raycaster */](),
			mouse: new __WEBPACK_IMPORTED_MODULE_0_three__["j" /* Vector2 */](),
			width: 0,
			height: 0,
			shaded: true,
			zoom: 3
		};
	},
	mounted: function mounted() {
		this.updateDimensions();
		var aspect = this.width / this.height;
		var camera = new __WEBPACK_IMPORTED_MODULE_0_three__["b" /* PerspectiveCamera */](50, aspect, 1, 10000);
		this.$store.state.scene.add(camera);
		this.$store.state.camera = camera;

		this.renderer = new __WEBPACK_IMPORTED_MODULE_0_three__["h" /* WebGLRenderer */]({
			alpha: true,
			antialias: false,
			canvas: this.$el.getElementsByTagName("canvas")[0]
		});
		this.renderer.setPixelRatio(window.devicePixelRatio);
		this.renderer.setSize(this.width, this.height);

		// this.controls = new OrbitControls(camera, this.$el);
		// this.controls.enabled = true;

		// Start the rendering loop:
		this.loop();
	},

	methods: {
		loop: function loop() {
			var scene = this.$store.state.scene;
			var camera = this.$store.state.camera;

			if (this.mouseControlEnabled) {
				camera.position.x += (this.mouse.x - camera.position.x) * .05;
				camera.position.y += (-this.mouse.y - camera.position.y) * .05;
				camera.lookAt(scene.position);
			}

			requestAnimationFrame(this.loop);
			this.renderer.render(scene, camera);
		},

		// Returns position in 2D coordinates for point in 3D space:
		getPosition2D: function getPosition2D(point, camera, callback) {
			var result = point.clone().project(camera);
			if (typeof callback === "function") {
				callback(result);
				return;
			}
			return result;
		},
		// Normalize 2D coordinates to center (camera):
		normalizeToCenter: function normalizeToCenter(point, el, callback) {
			var result = new __WEBPACK_IMPORTED_MODULE_0_three__["j" /* Vector2 */]();
			result.x = point.x / el.clientWidth * 2 - 1;
			result.y = -(point.y / el.clientHeight) * 2 + 1;
			if (typeof callback === "function") {
				callback(result);
				return;
			}
			return result;
		},

		// Normalize 2D coordinates to corner (typical HTML):
		normalizeToCorner: function normalizeToCorner(point, el) {
			return new __WEBPACK_IMPORTED_MODULE_0_three__["j" /* Vector2 */](point.x * (el.clientWidth / 2) + el.clientWidth / 2, -1 * point.y * (el.clientHeight / 2) + el.clientHeight / 2);
		},
		raycast: function raycast(type) {
			var intersects = void 0,
			    position = void 0;
			position = this.normalizeToCenter(this.mouse, this.$el);
			this.raycaster.setFromCamera(position, this.$store.state.camera);
			intersects = this.raycaster.intersectObjects(this.$store.state.scene.children, true);
			if (intersects.length > 0) {
				this.$emit('intersects', intersects.length);
			}
		},

		// Mouse move:
		mousemove: function mousemove(e) {
			if (!this.mouseControlEnabled) return;
			this.mouse.x = e.offsetX - this.width / 2;
			this.mouse.y = e.offsetY - this.height / 2;
			// this.mouse.x = e.offsetX;
			// this.mouse.y = e.offsetY;
			this.raycast("mousemove");
		},

		// Mouse down:
		mousedown: function mousedown(e) {
			if (!this.mouseControlEnabled) return;
			this.raycast("mousedown");
		},

		// Mouse up:
		mouseup: function mouseup(e) {
			if (!this.mouseControlEnabled) return;
			this.raycast("mouseup");
		},
		updateDimensions: function updateDimensions() {
			this.width = this.$el.offsetWidth;
			this.height = this.$el.offsetHeight;
		},
		onResize: function onResize(e) {
			this.updateDimensions();

			var camera = this.$store.state.camera;
			camera.aspect = this.width / this.height;
			camera.updateProjectionMatrix();

			this.renderer.setSize(this.width, this.height);
		}
	}
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WaveScene__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WaveScene___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__WaveScene__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'three-remix',
	components: { WaveScene: __WEBPACK_IMPORTED_MODULE_0__WaveScene___default.a },
	mounted: function mounted() {
		var camera = this.$store.state.camera;
		camera.position.set(1290, 240, 2000);
		camera.rotation.set(-0.11979, 0.56976, 0.06484);
	}
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PerspectiveViewport__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PerspectiveViewport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PerspectiveViewport__);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'wave-scene',
	components: {
		PerspectiveViewport: __WEBPACK_IMPORTED_MODULE_1__PerspectiveViewport___default.a
	},
	props: {
		mouseControlEnabled: {
			type: Boolean,
			required: false,
			default: false
		},
		framesPerSecond: {
			type: Number,
			required: false,
			default: 60
		}
	},
	data: function data() {
		return {
			count: 0,
			particles: new __WEBPACK_IMPORTED_MODULE_0_three__["c" /* Points */](),
			SEPARATION: 100,
			AMOUNTX: 50,
			AMOUNTY: 50
		};
	},
	mounted: function mounted() {
		var _this = this;

		var camera = this.$store.state.camera;
		camera.position.set(-2064.68917, 346.34446, -1157.06702);
		camera.rotation.set(-2.85075, -1.04149, -2.88875);

		this.$nextTick(function () {
			// Build the Three.js scene:
			var numParticles = _this.AMOUNTX * _this.AMOUNTY;

			var positions = new Float32Array(numParticles * 3);
			var scales = new Float32Array(numParticles);

			var i = 0,
			    j = 0;
			for (var ix = 0; ix < _this.AMOUNTX; ix++) {
				for (var iy = 0; iy < _this.AMOUNTY; iy++) {
					positions[i] = ix * _this.SEPARATION - _this.AMOUNTX * _this.SEPARATION / 2; // x
					positions[i + 1] = 0; // y
					positions[i + 2] = iy * _this.SEPARATION - _this.AMOUNTY * _this.SEPARATION / 2; // z
					scales[j] = 1;
					i += 3;
					j++;
				}
			}

			var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["d" /* BufferGeometry */]();
			geometry.addAttribute('position', new __WEBPACK_IMPORTED_MODULE_0_three__["e" /* BufferAttribute */](positions, 3));
			geometry.addAttribute('scale', new __WEBPACK_IMPORTED_MODULE_0_three__["e" /* BufferAttribute */](scales, 1));

			var material = new __WEBPACK_IMPORTED_MODULE_0_three__["f" /* ShaderMaterial */]({
				uniforms: {
					color: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["g" /* Color */](0xffffff) }
				},
				vertexShader: 'attribute float scale;\n\t\t\t\t\tvoid main() {\n\t\t\t\t\t\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t\t\tgl_PointSize = scale * ( 300.0 / - mvPosition.z );\n\t\t\t\t\t\tgl_Position = projectionMatrix * mvPosition;\n\t\t\t\t\t}',
				fragmentShader: 'uniform vec3 color;\n\t\t\t\t\tvoid main() {\n\t\t\t\t\t\tif ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;\n\t\t\t\t\t\tgl_FragColor = vec4( color, 1.0 );\n\t\t\t\t\t}'
			});

			_this.particles = new __WEBPACK_IMPORTED_MODULE_0_three__["c" /* Points */](geometry, material);
			_this.particles.name = "myParticles";
			_this.$store.state.scene.add(_this.particles);

			setInterval(function () {
				return _this.loop();
			}, 1000 / _this.framesPerSecond);
		});
	},

	methods: {
		loop: function loop() {
			var position = this.particles.geometry.attributes.position;
			var scale = this.particles.geometry.attributes.scale;
			var i = 0,
			    j = 0;
			for (var ix = 0; ix < this.AMOUNTX; ix++) {
				for (var iy = 0; iy < this.AMOUNTY; iy++) {
					position.array[i + 1] = Math.sin((ix + this.count) * 0.3) * 50 + Math.sin((iy + this.count) * 0.5) * 50;
					scale.array[j] = (Math.sin((ix + this.count) * 0.3) + 1) * 8 + (Math.sin((iy + this.count) * 0.5) + 1) * 8;
					i += 3;
					j++;
				}
			}
			position.needsUpdate = true;
			scale.needsUpdate = true;
			this.count += 0.1;
		}
	}
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'connect',
	data: function data() {
		return {
			links: [{
				label: 'LinkedIn',
				url: 'https://www.linkedin.com/in/rachelfrantsen/',
				description: 'Connect with me on LinkedIn'
			}, {
				label: 'Twitter',
				url: 'https://twitter.com/rachelfrantsen',
				description: 'Say hello on Twitter'
			}, {
				label: 'GitHub',
				url: 'https://github.com/frantsen',
				description: 'Explore code I\'ve written'
			}, {
				label: 'Email',
				url: 'mailto:rachelfrantsen@gmail.com',
				description: 'Send me a good old-fashioned email'
			}],
			mobile: false
		};
	},
	methods: {
		fullImgPath: function fullImgPath(name) {
			var imagePath = __webpack_require__(127);
			return imagePath('./' + name.toLowerCase() + '.svg');
		}
	}
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WaveScene__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WaveScene___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__WaveScene__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'cover',
	components: {
		WaveScene: __WEBPACK_IMPORTED_MODULE_0__WaveScene___default.a
	},
	methods: {
		navigateNext: function navigateNext() {
			var screenName = 'intro';
			var vm = this;
			this.$scrollTo('#screen-' + screenName, {
				onDone: function onDone() {
					vm.$emit('navigate', screenName);
				},

				duration: 300,
				easing: 'ease-out',
				cancelable: true
			});
		}
	}
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'error-404'
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'intro',
	methods: {
		fullImgPath: function fullImgPath(name) {
			var imagePath = __webpack_require__(126);
			return imagePath('./' + name);
		}
	}
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SnapshotLineType = {
	Addition: 'addition',
	Deletion: 'deletion',
	NoChange: 'nochange'
};

var Commit = function Commit(hashLabel, message, date, additions, modifications) {
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Commit);

	this.hashLabel = hashLabel;
	this.message = message;
	this.date = date;
	this.additions = additions || [];
	this.modifications = modifications || [];
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'skills',
	data: function data() {
		return {
			idxSelectedCommit: 9,
			commits: [new Commit('e1b6410', 'Inspired by my dad\'s site & others', new Date(2002, 0), ['HTML: Personal site 1.0']), new Commit('c0061d0', 'Recursion clicks; coding is awesome', new Date(2015, 1), ['Python']), new Commit('f523646', 'First tech gig!', new Date(2015, 5), ['JavaScript'], [{ original: 'HTML: Personal site 1.0', modified: 'HTML' }]), new Commit('85aaa3f', 'Software design; TA for Intro', new Date(2015, 8), undefined, [{ original: 'Python', modified: 'Python' }]), new Commit('g3002a0', 'Recursive AND minimalistic?? Sweet!', new Date(2016, 1), ['SQL', 'Scheme', 'Android'], [{ original: 'C++', modified: 'C++' }]), new Commit('eb9f3c5', 'Intern at Protolabs Inc.', new Date(2016, 5), ['ASP.NET MVC', 'C#'], [{ original: 'HTML', modified: 'HTML' }, { original: 'SQL', modified: 'SQL Server' }]), new Commit('46c390e', 'Adventures in scripting', new Date(2016, 8), ['Bash']), new Commit('7530344', 'C++ level up with ALGORITHMS', new Date(2017, 1), undefined, [{ original: 'C++', modified: 'C++' }]), new Commit('0f830e9', 'Protolabs ECommerce overhaul', new Date(2017, 5), ['PowerShell', 'Jest', 'Entity Framework Core'], [{ original: 'JavaScript', modified: 'Vue.js' }, { original: 'ASP.NET MVC', modified: '.NET Core' }]), new Commit('dcf18cf', 'Facebook, VR, Oculus, and Horizon', new Date(2020, 11), ['ReactVR', 'Relay', 'Unity', 'GraphQL', 'PHP (Hacklang)']), new Commit('1ccab09', 'Horizon by Facebook VR is now Meta Horizon', new Date(2021, 11), [], [{ original: 'C#', modified: 'C#' }, { original: 'ReactVR', modified: 'ReactVR' }, { original: 'Relay', modified: 'Relay' }, { original: 'Unity', modified: 'Unity' }, { original: 'GraphQL', modified: 'GraphQL' }, { original: 'PHP (Hacklang)', modified: 'PHP (Hacklang)' }])]
		};
	},
	computed: {
		snapshots: function snapshots() {
			var _this = this;

			return this.commits.reduce(function (snapshots, commit, index, _) {
				var lastSnapshot = index === 0 ? [] : snapshots[index - 1];
				var currentSnapshot = lastSnapshot.filter(function (l) {
					return l.type !== SnapshotLineType.Deletion;
				}).map(function (i) {
					return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, i);
				});

				var deletionKeys = commit.modifications.map(function (m) {
					return m.original;
				});
				currentSnapshot.forEach(function (l) {
					return l.type = deletionKeys.includes(l.content) ? SnapshotLineType.Deletion : SnapshotLineType.NoChange;
				});

				currentSnapshot = currentSnapshot.concat(commit.additions.concat(commit.modifications.map(function (m) {
					return m.modified;
				}) || []).map(function (c) {
					return {
						content: c,
						type: SnapshotLineType.Addition,
						message: commit.message,
						date: commit.date
					};
				})).sort(_this.snapshotLineSort);

				snapshots.push(currentSnapshot);
				return snapshots;
			}, []);
		},
		commitsDescending: function commitsDescending() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.commits.map(function (c) {
				return {
					hashLabel: c.hashLabel,
					date: c.date
				};
			})).reverse();
		},
		commitSource: function commitSource() {
			return this.snapshots[this.idxSelectedCommit];
		}
	},
	filters: {
		timeSinceDate: function timeSinceDate(date) {
			var seconds = Math.floor((new Date() - date) / 1000);
			var intervals = [{ sec: 31536000, type: 'year' }, { sec: 2592000, type: 'month' }, { sec: 86400, type: 'day' }, { sec: 3600, type: 'hour' }, { sec: 60, type: 'minute' }];
			var interval = intervals.find(function (i) {
				return Math.floor(i.sec < seconds);
			});
			if (!interval) {
				return 'a moment ago';
			}
			var count = Math.floor(seconds / interval.sec);
			return count + ' ' + interval.type + (count > 1 ? 's' : '') + ' ago';
		}
	},
	methods: {
		selectCommit: function selectCommit(descIdxSelected) {
			this.idxSelectedCommit = this.commits.length - 1 - descIdxSelected;
		},

		snapshotLineSort: function snapshotLineSort(a, b) {
			return a.content > b.content ? 1 : a.content < b.content ? -1 : a.type === SnapshotLineType.Deletion ? -1 : b.type === SnapshotLineType.Deletion ? 1 : 0;
		}
	}
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_google_analytics__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_google_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scripts_google_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (to, from) {
	ga('set', 'page', to.fullPath);
	ga('send', 'pageview');
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/portrait.747a53e.png";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NC45MyA0NC45MyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmMDg3MWU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5lbWFpbDwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjEwLjQ1IDE2LjQ0IDEwLjQ1IDMxLjAyIDM0LjQ4IDMxLjAyIDM0LjQ4IDE2LjQ0IDIyLjQyIDI2LjE2IDEwLjQ1IDE2LjQ0Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjM0LjM5IDEzLjkyIDEwLjQ1IDEzLjkyIDIyLjQyIDIzLjY0IDM0LjM5IDEzLjkyIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjEwLjUxIDE2LjQ1IDEwLjUxIDMxIDM0LjUxIDMxIDM0LjUxIDE2LjQ1IDIyLjQ3IDI2LjE1IDEwLjUxIDE2LjQ1Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjM0LjQyIDEzLjkzIDEwLjUxIDEzLjkzIDIyLjQ3IDIzLjY0IDM0LjQyIDEzLjkzIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjIuNTUsMEEyMi40NywyMi40NywwLDEsMCw0NSwyMi41LDIyLjQ3LDIyLjQ3LDAsMCwwLDIyLjU1LDBaTTM0LjUsMTRsLTEyLDkuNzFMMTAuNTksMTRaTTM0LjU5LDMxaC0yNFYxNi40OGwxMiw5LjcxLDEyLTkuNzFWMzFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wOCAtMC4wMykiLz48L3N2Zz4="

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDUxMiA1MTIiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48Zz48Y2lyY2xlIGN4PSIyNTYiIGN5PSIyNTYiIGZpbGw9IiMzMzMzMzMiIHI9IjI1NiIvPjxnPjxwYXRoIGQ9Ik0yNTYsOTMuOWMtODkuNSwwLTE2Mi4xLDcyLjYtMTYyLjEsMTYyLjFjMCw3MC41LDQ1LDEzMC40LDEwNy44LDE1Mi44YzAuMywwLjEsMS40LDAuNSwxLjcsMC42ICAgIGMwLjksMC4zLDEuOSwwLjUsMi45LDAuNWM1LjMsMCw5LjUtNC4zLDkuNS05LjVjMC0wLjMsMC0wLjUsMC0wLjhsMCwwYzAtOC42LDAtMTkuNSwwLTI4LjJjLTEwLjMsMi4xLTI1LjksNC4xLTM0LjQsMCAgICBjLTExLTUuMy0xNi42LTEyLjEtMjEuOS0yNS41Yy02LjYtMTYuMy0yMS44LTIwLjgtMjIuNC0yMy42Yy0wLjYtMi45LDE2LjEtNy4yLDI0LjcsMi43YzguNiw5LjksMTcuMywyOS43LDM1LjgsMjcuOCAgICBjOS4xLTAuOSwxNS0yLjQsMTguNy0zLjVjMC43LTYuNCwyLjgtMTQuMyw4LjEtMTkuOWMtNDMuNS03LjItNzIuNS0zMC42LTcyLjUtNzYuNWMwLTIwLjksNi0zNy4xLDE2LjYtNDkuMiAgICBjLTEuOC0xMC00LjgtMzMuMiwzLjItNDEuM2MwLDAsMTEuMy03LDQzLjcsMTUuOGMxMi4xLTIuOCwyNS41LTQuMiwzOS44LTQuMmwwLDBjMC4zLDAsMC41LDAsMC44LDBjMC4zLDAsMC41LDAsMC44LDBsMCwwICAgIGMxNC40LDAuMSwyNy44LDEuNSwzOS44LDQuMmMzMi40LTIyLjgsNDMuNy0xNS44LDQzLjctMTUuOGM4LDguMiw1LDMxLjQsMy4yLDQxLjNjMTAuNiwxMi4yLDE2LjYsMjguNCwxNi42LDQ5LjIgICAgYzAsNDUuOS0yOC45LDY5LjMtNzIuNSw3Ni41YzguMyw4LjcsOC42LDIyLjgsOC42LDI4LjZjMCw1LjUsMCw0Mi4zLDAsNDIuNWMwLDUuMyw0LjMsOS41LDkuNSw5LjVjMC44LDAsMS41LTAuMSwyLjMtMC4zICAgIGMwLjIsMCwwLjgtMC4yLDEtMC4zYzYzLjUtMjIsMTA5LjEtODIuMywxMDkuMS0xNTMuM0M0MTguMSwxNjYuNCwzNDUuNSw5My45LDI1Niw5My45eiIgZmlsbD0iI0ZGRkZGRiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDQ4IDQ4IiBpZD0iTGF5ZXJfMSIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNDggNDgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxjaXJjbGUgY3g9IjI0IiBjeT0iMjQiIGZpbGw9IiMxNjg2QjAiIHI9IjI0Ii8+PHBhdGggZD0iTTE3LjQsMzQuOWgtNC42VjIwLjFoNC42VjM0Ljl6IE0xNC45LDE4LjJMMTQuOSwxOC4yYy0xLjcsMC0yLjgtMS4xLTIuOC0yLjZjMC0xLjUsMS4xLTIuNiwyLjgtMi42ICBjMS43LDAsMi44LDEuMSwyLjgsMi42QzE3LjcsMTcuMSwxNi43LDE4LjIsMTQuOSwxOC4yeiBNMzUuOSwzNC45aC01LjN2LTcuN2MwLTItMC44LTMuNC0yLjYtMy40Yy0xLjQsMC0yLjEsMC45LTIuNSwxLjggIGMtMC4xLDAuMy0wLjEsMC44LTAuMSwxLjJ2OGgtNS4yYzAsMCwwLjEtMTMuNiwwLTE0LjhoNS4ydjIuM2MwLjMtMSwyLTIuNSw0LjYtMi41YzMuMywwLDUuOSwyLjEsNS45LDYuN1YzNC45eiIgZmlsbD0iI0ZGRkZGRiIvPjwvc3ZnPg=="

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NC45IDQ0LjkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojNTNiYmVhO308L3N0eWxlPjwvZGVmcz48dGl0bGU+dHdpdHRlcjwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIuNTUsMEEyMi40NSwyMi40NSwwLDEsMCw0NSwyMi40NSwyMi40NiwyMi40NiwwLDAsMCwyMi41NSwwWk0zMy44NiwxOEExNS4xOSwxNS4xOSwwLDAsMSwxOC42LDM0YTE1LjM2LDE1LjM2LDAsMCwxLTguMjYtMi40MiwxMC40NCwxMC40NCwwLDAsMCw3LjktMi4yNCw1LjQzLDUuNDMsMCwwLDEtNS0zLjY4LDUuNDgsNS40OCwwLDAsMCwyLjQyLS4wOSw1LjM1LDUuMzUsMCwwLDEtNC4zMS01LjMsNS4zOSw1LjM5LDAsMCwwLDIuNDIuNjMsNS4zMiw1LjMyLDAsMCwxLTEuNjItNy4xOCwxNC45MywxNC45MywwLDAsMCwxMSw1LjU3LDUuMzcsNS4zNywwLDAsMSw5LjE2LTQuODUsMTQuMDYsMTQuMDYsMCwwLDAsMy40MS0xLjI2LDUuMTUsNS4xNSwwLDAsMS0yLjMzLDMsMTAuOSwxMC45LDAsMCwwLDMuMDUtLjgxQTEwLjUyLDEwLjUyLDAsMCwxLDMzLjg2LDE4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMSkiLz48L3N2Zz4="

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74ebf3eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-351f9fa0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(113),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a2a03352",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01a9ecf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(116),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36067244",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(121),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e23f51f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65b66e56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect"
  }, [_c('div', {
    staticClass: "social-container"
  }, _vm._l((_vm.links), function(link, index) {
    return _c('a', {
      key: ("social-link-" + index),
      attrs: {
        "href": link.url
      }
    }, [_c('div', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": _vm.fullImgPath(link.label),
        "alt": link.label
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "social-description"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(link.description) + "\n\t\t\t\t")])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize.debounce",
      value: (_vm.onResize),
      expression: "onResize",
      modifiers: {
        "debounce": true
      }
    }],
    staticClass: "viewport perspective",
    on: {
      "mousedown": _vm.mousedown,
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup
    }
  }, [_c('canvas', {
    staticClass: "layer3D"
  })])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "title mobile-hide"
  }, [_vm._v("Rachel Frantsen Lee | " + _vm._s(_vm._f("title")(_vm.active)) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper mobile-hide"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: ("nav-item-" + index),
      staticClass: "nav-item",
      class: {
        active: item === _vm.active
      },
      on: {
        "click": function($event) {
          return _vm.navigateTo(item)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("title")(item)) + "\n\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mobile-label mobile-show"
  }, [_vm._v("\n\t\t" + _vm._s(_vm._f("title")(_vm.active)) + "\n\t")])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "error-404"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_c('h1', [_vm._v("404")]), _vm._v("\n\tClick screen or tap to go Home.\n")])
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "animation-underlay"
  }), _vm._v(" "), _c('wave-scene', {
    staticClass: "animation-tile",
    attrs: {
      "framesPerSecond": 30
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-text"
  }, [_vm._v("Rachel Frantsen Lee")]), _vm._v(" "), _c('div', {
    staticClass: "clickable-overlay",
    on: {
      "click": _vm.navigateNext
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skills"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "commit-list"
  }, _vm._l((_vm.commitsDescending), function(commit, index) {
    return _c('div', {
      key: ("commit-hash-" + index)
    }, [_c('div', {
      staticClass: "commit-wrapper"
    }, [_c('div', {
      staticClass: "hash-link",
      on: {
        "click": function($event) {
          return _vm.selectCommit(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(commit.hashLabel) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "align-right"
    }, [_vm._v(_vm._s(_vm._f("timeSinceDate")(commit.date)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "diff-display"
  }, _vm._l((_vm.commitSource), function(line, index) {
    return _c('div', {
      key: ("src-line-" + index)
    }, [_c('div', {
      class: ['diff-line', line.type]
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(line.content) + "\n\t\t\t\t\t"), _c('div', {
      staticClass: "message"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(line.message) + "\n\t\t\t\t\t")])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('perspective-viewport', {
    attrs: {
      "mouseControlEnabled": _vm.mouseControlEnabled
    }
  })
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, _vm._l((_vm.screens), function(screen, index) {
    return _c('div', {
      key: ("screen-index-" + index),
      staticClass: "screen",
      attrs: {
        "id": ("screen-" + screen)
      }
    }, [(screen !== 'cover') ? _c('nav-menu', {
      attrs: {
        "active": screen,
        "items": _vm.screens
      }
    }) : _vm._e(), _vm._v(" "), _c(screen, {
      tag: "component"
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "three-remix"
  }, [_c('wave-scene', {
    staticClass: "frame",
    attrs: {
      "mouseControlEnabled": ""
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-text"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/mrdoob/three.js/blob/master/examples/webgl_points_waves.html"
    }
  }, [_vm._v("MrDoob")]), _vm._v(" x\n\t\t"), _c('a', {
    attrs: {
      "href": "https://github.com/ianpaschal/three-vue-viewport/blob/master/src/PerspectiveViewport.js"
    }
  }, [_vm._v("IanPaschal")]), _vm._v(" x\n\t\t"), _c('a', {
    attrs: {
      "href": "https://github.com/frantsen/portfolio/tree/master/src/components/ThreeRemix.vue"
    }
  }, [_vm._v("Frantsen")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "overlay-subtext"
  }, [_vm._v("\n\t\t\tutilizing\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://threejs.org"
    }
  }, [_vm._v("Three.js")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API"
    }
  }, [_vm._v("WebGL")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://vuejs.org"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://vuex.vuejs.org"
    }
  }, [_vm._v("Vuex")])])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "stripe"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.fullImgPath('portrait.png'),
      "alt": "Portrait"
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stripe-intro"
  }, [_c('main', [_c('p', [_vm._v("\n\t\t\t\t\ttrilingual nerd fluent in human, musical, and computer languages,\n\t\t\t\t\tand passionate about becoming a better communicator in all three.\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tbringing interdisciplinary perspectives and creativity to code since Hello world in 2015.\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tthis responsive site built "), _c('b', [_vm._v("from scratch")]), _vm._v(" & configured by hand. see "), _c('a', {
    attrs: {
      "href": "https://github.com/frantsen/portfolio"
    }
  }, [_vm._v("here")]), _vm._v(" for behind-the-scenes.\n\t\t\t\t")])])])
}]}

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./portrait.png": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./email.svg": 97,
	"./github.svg": 98,
	"./linkedin.svg": 99,
	"./medium.svg": 100,
	"./twitter.svg": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;

/***/ })
]),[49]);


// WEBPACK FOOTER //
// static/js/app.4053861f7c52bfe0b83f.js